import moment from 'moment';
import formatDate from '@/services/general/formatDate';
import { formatDevise } from '@/services/general/filters/formatDevise';
import { BLOQUE } from '@/configuration/optionBlocage/optionBlocage';
import getNbFacesByEtatObtenu from '@/services/optionBlocage/getNbFacesByEtatObtenu';

function updateEtatAndResteAVendreAndNonDispo(ligneFormater, i18n) {
  let nbFaceBloque = 0;
  ligneFormater.affectations.forEach((affectation) => {
    if (affectation.etatObtenu === BLOQUE) nbFaceBloque += affectation.nbFaces;
  });
  ligneFormater.facesNonDispo = nbFaceBloque;
  ligneFormater.resteAVendre = ligneFormater.facesPrevues - nbFaceBloque;
  const nbFaces = getNbFacesByEtatObtenu(ligneFormater.affectations);
  if (nbFaces.nbFaceDevis > 0) ligneFormater.etat = i18n.t('reseauTempo.legende.bloqueDevis');
  else if (nbFaces.nbFaceCommande > 0) ligneFormater.etat = i18n.t('reseauTempo.legende.bloqueCommande');
  else if (nbFaces.nbFaceFacture > 0) ligneFormater.etat = i18n.t('reseauTempo.legende.facture');
  else if (nbFaces.nbFaceBloqueOption > 0) ligneFormater.etat = i18n.t('reseauTempo.legende.option');
  else if (nbFaces.nbFaceRelanceOption > 0) ligneFormater.etat = i18n.t('reseauTempo.legende.relanceOption');
}

function getFormat(formatId, listFormats) {
  const formatFind = listFormats.find((format) => {
    return format.id === formatId;
  });
  return formatFind ? formatFind.libelle : null;
}

function updateTarifAndTaxe(ligneFormater, ligne) {
  let totalTarif = 0;
  let totalTaxe = 0;
  let totalFrais = 0;
  ligne.lignesCommande.forEach((ligneCommande) => {
    if (ligneCommande.produit.produitDivers) {
      if (ligneCommande.produit.produitDivers.tlpe) {
        totalTaxe += ligneCommande.totalHt;
      } else {
        totalFrais += ligneCommande.totalHt;
      }
    } else totalTarif += ligneCommande.totalHt;
  });
  ligneFormater.tarifCurrency = totalTarif;
  ligneFormater.taxeCurrency = totalTaxe;
  ligneFormater.fraisCurrency = totalFrais;
  ligneFormater.tarif = formatDevise(totalTarif);
  ligneFormater.taxe = formatDevise(totalTaxe);
  ligneFormater.frais = formatDevise(totalFrais);
}
function donneNbFacesReel(affectationsReseauFace, dateDepart) {
  const dateVisu = dateDepart.toDate();
  return affectationsReseauFace.filter(a => {
    return moment(a.dateDebut).toDate() <= dateVisu
      && (a.dateFin === null || a.dateFin === '' || moment(a.dateFin).toDate() >= dateVisu);
  }).length;
}

export default function formatListReseauTempoDispoForExcel(lignesCommande, listFormats, i18n) {
  const listFormatterReseauTempoDispo = [];
  lignesCommande.forEach((ligne) => {
    const reseauTempoFormat = {
      reference: ligne.produit.reference,
      libelle: ligne.produit.libelle,
      ville: ligne.produit.produitReseau.adresse.ville,
      format: getFormat(ligne.produit.produitReseau.formatId, listFormats),
      facesPrevues: ligne.ligneReseau.qteFacesPrevues,
      facesReelles: ligne.produit.produitReseau.affectationsReseauFace.length,
      dateDebut: formatDate(ligne.dateDebut),
      tarif: 0,
      tarifCurrency: 0,
      taxe: 0,
      taxeCurrency: 0,
      frais: 0,
      fraisCurrency: 0,
      etat: i18n.t('reseauTempo.legende.libre'),
      resteAVendre: ligne.ligneReseau.qteFacesPrevues,
      affectations: ligne.affectation,
      facesNonDispo: 0,
      id: ligne.produit.id,
      departement: ligne.produit.produitReseau.adresse.departement,
      semaine: i18n.t('listeDemandeTempo.card.anneeSemaine', {
        week: ligne.ligneReseau.anneeSemaine.toString().substring(4, 6),
      }),
      annee: ligne.ligneReseau.anneeSemaine.toString().substring(0, 4),
    };
    reseauTempoFormat.facesReelles = donneNbFacesReel(
      ligne.produit.produitReseau.affectationsReseauFace,
      ligne.dateDebut,
    );
    updateTarifAndTaxe(reseauTempoFormat, ligne);
    updateEtatAndResteAVendreAndNonDispo(reseauTempoFormat, i18n);
    listFormatterReseauTempoDispo.push(reseauTempoFormat);
  });
  return listFormatterReseauTempoDispo;
}
